<template>
  <div>
    <header-component />
    <div class="container-fluid mt--6">
      <div class="card">
        <div class="card-header">
          <h3 class="mb-0" style="text-transform: capitalize">
            Quotation List
          </h3>
          <div class="text-right col-lg-12 col-5">
            <div class="table-filters">
              <el-tag
                v-for="(tag, index) in filters"
                :key="index"
                :disable-transitions="false"
                closable
                @close="removeFilter(index)"
              >
                <span v-if="tag">
                  {{ tag.field }}:
                  <span style="font-weight: bold">
                    {{ tag.value }}
                    <span />
                  </span>
                </span>
              </el-tag>
            </div>
            <el-popover
              v-model="filterPopUpVisible"
              placement="left"
              width="550"
            >
              <table-filter @apply="applyFilters" />
              <base-button slot="reference" size="sm" type="primary"
                >Add Filter</base-button
              >
            </el-popover>
          </div>
        </div>
        <el-table
          :data="quotationList"
          class="table-responsive table-flush"
          header-row-class-name="thead-light"
        >
          <el-table-column label="Date" min-width="70">
            <template slot-scope="scope">{{
              scope.row.updatedAt | dateFormat
            }}</template>
          </el-table-column>
          <el-table-column
            min-width="60"
            label="Quote. No."
            prop="quotationNumber"
          />
          <el-table-column label="Type" prop="type" />
          <el-table-column label="Customer">
            <template slot-scope="scope">
              {{ scope.row.user.firstName + " " + scope.row.user.lastName }}
            </template>
          </el-table-column>
          <el-table-column label="Vendor">
            <template slot-scope="scope">
              {{ scope.row.vendor.firstName + " " + scope.row.vendor.lastName }}
            </template>
          </el-table-column>
          <el-table-column label="Status">
            <template slot-scope="scope">
              <span v-if="scope.row.status">
                <el-tag
                  v-if="scope.row.status.code === 'pending'"
                  class="pending-status"
                  effect="dark"
                >
                  {{ scope.row.status.label }}
                </el-tag>
                <el-tag
                  v-else-if="scope.row.status.code === 'dispatched'"
                  class="dispatch-status"
                  effect="dark"
                >
                  {{ scope.row.status.label }}
                </el-tag>
                <el-tag
                  v-else-if="scope.row.status.code === 'accepted'"
                  type="success"
                  effect="dark"
                >
                  {{ scope.row.status.label }}
                </el-tag>
                <el-tag
                  v-else-if="scope.row.status.code === 'declined'"
                  class="declined-status"
                  effect="dark"
                >
                  {{ scope.row.status.label }}
                </el-tag>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="Actions">
            <template slot-scope="scope">
              <el-dropdown
                slot="dropdown"
                @command="command => handleAction(scope.row, command)"
              >
                <el-button type="primary" size="mini"> Actions </el-button>
                <el-dropdown-menu
                  slot="dropdown"
                  class="dropdown-menu dropdown-menu-arrow show"
                >
                  <el-dropdown-item
                    v-if="scope.row.type === 'Detailed Product Quotation'"
                    command="details"
                    >View Details</el-dropdown-item
                  >
                  <el-dropdown-item command="printQuotation"
                    >Send To WhatsApp</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <div class="card-footer">
          <div
            v-if="quotationMeta"
            slot="footer"
            class="flex-wrap col-12 d-flex justify-content-center justify-content-sm-between"
          >
            <div class>
              <p class="card-category">
                Showing {{ quotationMeta.from + 1 }} to
                {{ quotationMeta.to }} of {{ quotationMeta.total }} entries
                <span v-if="selectedRows.length"
                  >&nbsp; &nbsp; {{ selectedRows.length }} rows selected</span
                >
              </p>
            </div>
            <pagination :meta="quotationMeta" @paginate="setPagination" />
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="showQuotationModal"
      title="Quotation Invoice"
      width="50%"
    >
      <service-request-quotation-design
        :data="quotationData"
        @close="showQuotationModal = false"
      />
    </el-dialog>
  </div>
</template>

<script>
import headerComponent from "../Components/HeaderComponent";
import { mapActions, mapState, mapGetters } from "vuex";
import dateFns from "date-fns";
import { print } from "@/utils/print";

import {
  Select,
  Option,
  DatePicker,
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Dialog,
  Tag,
  Button
} from "element-ui";
import pagination from "@/components/AmsaPagination";
import tableFilter from "../../components/QuotationListFilter.vue";
import ServiceRequestQuotationDesign from "./ServiceRequestQuotationDesign.vue";

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    [Dialog.name]: Dialog,
    [Tag.name]: Tag,
    [Button.name]: Button,
    pagination,
    "header-component": headerComponent,
    "table-filter": tableFilter,
    "service-request-quotation-design": ServiceRequestQuotationDesign
  },
  filters: {
    dateFormat(value) {
      return dateFns.format(value, "DD MMM YYYY");
    }
  },
  data: () => {
    return {
      serviceRequestQuotationData: {},
      selectedRows: [],
      pageSize: 10,
      filters: [],
      filterPopUpVisible: false,
      showQuotationModal: false,
      quotationData: {}
    };
  },
  computed: {
    ...mapState("serviceRequestQuotation", ["quotationList", "quotationMeta"]),
    ...mapGetters({
      statusList: "status/getStatusList",
      user: "user/getLoggedInUser"
    })
  },
  watch: {
    filters: {
      deep: true,
      handler: function(value, oldValue) {
        this.restructureFilters(value);
      }
    }
  },
  mounted() {
    this.getStatuses();
    const data = window.localStorage.getItem("quotationFilters");
    const parsedData = JSON.parse(data);
    if (data != null && parsedData.length != 0) {
      if (parsedData.length > 1) {
        const list = parsedData;
        this.filters.push(...list);
      } else {
        this.filters.push(...parsedData);
      }
    } else {
      this.paginate();
    }
  },
  methods: {
    ...mapActions({
      getAllQuotations: "serviceRequestQuotation/getQuotations",
      fetchServiceRequestQuotationDetails:
        "serviceRequestQuotation/getServiceRequestQuotationDetails",
      updateServiceRequestQuotation:
        "serviceRequestQuotation/updateServiceRequestQuotation",
      getStatuses: "status/getStatusList",
      printQuotation: "serviceRequestQuotation/printQuotation"
    }),
    async handleAction(row, command) {
      if (command === "details") {
        this.$router.push(`/quotation/${row.serviceRequestQuotationId}`);
      } else {
        if (print) {
          const quotationData = await this.fetchServiceRequestQuotationDetails(
            row.serviceRequestQuotationId
          );
          this.quotationData = quotationData;
          this.showQuotationModal = true;

          // print(quotationData, "quotation");
        }
      }
    },
    getServiceRequestQuotationDetails(row) {
      this.fetchServiceRequestQuotationDetails(
        row.serviceRequestQuotationId
      ).then(res => {
        row.details = res.data;
        this.serviceRequestQuotationData = res.data;
      });
    },
    updateQuotation(quotation) {
      const total = quotation.productMeta.reduce((a, b) => {
        return a + b.quantity * b.price;
      }, 0);
      const newStatus = this.statusList.find(i => i.code === "dispatched");
      this.updateServiceRequestQuotation({
        productMeta: quotation.productMeta,
        statusId: newStatus.statusId,
        serviceRequestQuotationId: quotation.serviceRequestQuotationId,
        total,
        approvedBy: this.user.userId
      }).then(res => {
        this.getAllQuotations();
        this.$notify({
          message: "Quotation Updated Succesfully!",
          type: "success",
          title: "Success"
        });
      });
    },
    setPagination(data) {
      this.pageSize = data.perPage;
      this.restructureFilters(this.filters, data.page);
    },
    paginate(page = 1, filters = {}) {
      let query = {
        page,
        perPage: this.pageSize,
        ...filters
      };
      this.getAllQuotations(query);
    },
    applyFilters(filters) {
      this.filters.push(filters);
      window.localStorage.setItem(
        "quotationFilters",
        JSON.stringify(this.filters)
      );
      this.filterPopUpVisible = false;
    },
    removeFilter(tagIndex) {
      this.filters.splice(tagIndex, 1);
      if (this.filters.length > 0) {
        window.localStorage.setItem(
          "quotationFilters",
          JSON.stringify(this.filters)
        );
      } else {
        window.localStorage.removeItem("quotationFilters");
      }
    },
    restructureFilters(value, page = 1) {
      const filtered = {};
      value.forEach(i => {
        if (i.field === "date") {
          filtered.fromDate = i.value[0];
          filtered.toDate = i.value[1];
        } else {
          filtered[i.field] = i.value;
        }
      });
      if (Object.entries(filtered).length > 0) {
        this.paginate(page, filtered);
      } else {
        this.paginate(page);
      }
    }
  }
};
</script>
<style>
.card .el-table th {
  padding-right: 0px;
}
.card .el-table td {
  padding-right: 1.5rem;
  padding-left: 14px;
}

.el-table .el-table__header .cell {
  padding: 5px;
}
.product-meta {
  display: flex;
  flex-direction: column;
  margin-left: 30px;
  margin-right: 30px;
}
.product-meta-item {
  display: flex;
}
.product-meta-item label {
  font-weight: 600;
  font-size: 13px;
  margin-right: 4px;
}
.card .product-quotation-card {
  width: 100%;
  margin: 10px;
}
.dispatch-button {
  margin-left: 15px;
  margin-top: 20px;
}
.pending-status {
  background-color: #e72626;
  border-color: #e72626;
  color: #fff;
}
.dispatch-status {
  background-color: #f57316eb;
  border-color: #f57316eb;
  color: #fff;
}
.declined-status {
  background-color: #b0ccb3;
  border-color: #b0ccb3;
  color: #fff;
}
.table-filters {
  display: inline-block;
}
.table-filters .el-tag {
  margin-left: 10px;
}
</style>
